export default __webpack_public_path__ + "static/media/client.564c4e55.svg";